import React, {useEffect, useState} from "react";
import {AppBar, Drawer, List, Toolbar} from "@material-ui/core";
import clsx from "clsx";
import Collapse from "@material-ui/core/Collapse";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {withRouter} from "react-router-dom";
import {useStyles} from "./styles";
import { subTabIcon, activeSubTabIcon} from "../../assets/images/img/index"; 
import {cmsLogo} from "../../assets/images/images"; 
import {getUserDataFromLocalStorage} from "../../services/utils";
import {downArrow, menuIcon, userProfile} from '../../assets/images/img/'
import {PrimaryButton} from '../../components'
import HttpServices from '../../services/http.service'
import { helpHandler, isLoggedIn, logout , getContentList}  from "../../store/actions";
import {connect} from "react-redux";
import {useDispatch,useSelector} from "react-redux";
import {FRONTEND_DOMAIN_PREFIX} from "../../environment";
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
// import BottomNavigation from '@material-ui/core/BottomNavigation';
// import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
const MySidebar = (props) => {
  const classes = useStyles();
  const {sidebar,restaurantReducer,location} = props;
  const {contentList, contentListError} = restaurantReducer;
  // const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(!isSmallScreen);

  const [userData, setUserData] = useState({});
  const [activeTab, setActiveTab] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("");
  const [profileOption, setProfileOption] = useState(false);

  useEffect(()=>{
    props.getContentStart({});
    // console.log("contentList",contentList);
    getUserDataFromLocalStorage()?dispatch(isLoggedIn()):dispatch(logout());  
  }, []);

  const _useEffect = () => {
    if (Boolean(window.navigator.vibrate)) {
      // It Supports

    }
    let userData = getUserDataFromLocalStorage();
    console.log("userData",userData);
    if (userData) {
      let username = userData?.name
      // username = username.replace(/\b\w/g, l => l.toUpperCase())
      // document.title = username
      // document.title =`<button onClick={()=>alert('hi ')}>username</button>`
      setUserData(userData);
      highlightActiveTab();
    }
  };

  const highlightActiveTab = () => {
    let pathname = props.history.location.pathname.split("/");
    let fullPath = props.history.location.pathname;
    let activeTab = pathname[pathname.length - 1];
    // console.log('this is active ', activeTab)
    if (activeTab) {
      // setActiveTab(activeTab);
      // if (fullPath.search('cp') >= 0) {
      //   // activeTab=
      //   // props.history.push(`/cp/${activeTab}`);
      // }
      // else if (activeTab !== 'dashboard')
      // console.log({activeTab})
      // props.history.push(`/${activeTab}`);
      // }
      // else {
      //     props.history.push('/dashboard')
    }
  };

  useEffect(_useEffect, []);
  const sideBarOptions= userData ? sidebar.filter(x=> x.role.includes(userData?.role_id?._id)) :null;
  //console.log("userData",userData);
  const _useEffectActiveTab = () => {

    let pathname = props.history.location.pathname.split("/");
    let fullPath = props.history.location.pathname;

    let activeTab = pathname[1];
    console.log("tabbbbbbb",activeTab);
    // As in case of Super Admin there is no tab for branch, table, category, menu, or order
    if(userData?.role_id?.type === 1 && (activeTab === 'branch'))
      activeTab = 'restaurant';
    // As in case of Restaurant Admin there is no tab for table, category, menu, or order
    // else if(userData?.role_id?.type === 2 && (
    //   activeTab === 'table' || activeTab === 'category' || activeTab === 'menu'
    // ))
    //   activeTab = 'branch';
      
    let tab=null;
    sideBarOptions?.forEach(element => {
      if(element.key==activeTab)
        tab=element;
    });
    setActiveTab(activeTab);
    if(tab?.subItems && tab.subItems.length)
    {
      setActiveSubTab(tab.subItems[0].text)
      //console.log("yesss sub category isss==",tab.subItems[0].text)
      props.history.push({pathname: `/${activeTab}`,state: {mainActiveParentCategory:tab.subItems[0], currentUser:userData}}); 
      return
    }
    console.log("userData",userData);
    if(activeTab === 'branch')
      props.history.push({pathname: `/${activeTab}`,state: {restaurant_id: userData.restaurant_id}}); 
    else if(activeTab === 'table')
      props.history.push({pathname: `/${activeTab}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else if(activeTab === 'category')
      props.history.push({pathname: `/${activeTab}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else if(activeTab === 'menu')
      props.history.push({pathname: `/${activeTab}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else if(activeTab === 'admin-category')
      props.history.push({pathname: `/${activeTab}`}); 
    else if(activeTab === 'admin-menu')
      props.history.push({pathname: `/${activeTab}`});
    else if(activeTab === 'order')
      props.history.push({pathname: `/${activeTab}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else
      props.history.push({pathname: `/${activeTab}`,state: { currentUser:userData}}); 
  };
  useEffect(_useEffectActiveTab, [activeTab]);

  function movetoFrontend(){
    //let userData = getUserDataFromLocalStorage();
    //if(userData.role._id=="63314f7edd5ccc5c401ab035"){
      let domLink=FRONTEND_DOMAIN_PREFIX+""
      window.location.replace(domLink); 
    //}
  }
  const onLogout = async () => {
    let userData = getUserDataFromLocalStorage(); 
    //console.log(" ====(==>)",userData);
    await localStorage.clear(); 
    await HttpServices.removeUser()
    //dispatch(logout());
    
    if(userData && userData?.role_id._id==userData?.role_id._id){
      props.history && props.history.push({pathname: `/`});  
    }
    else if(userData){ 
      let domLink=FRONTEND_DOMAIN_PREFIX+"/logout"
      window.location.replace(domLink); 
    }
    //   props.history && props.history.push({pathname: `/login`});
    // window.location.reload(false);
  };

  const viewProfile = () =>{
    let userData = getUserDataFromLocalStorage();
    // console.log("userData",userData);
    const restaurant_id = userData?.restaurant_id;
    // console.log("restaurant_id",restaurant_id);
    // console.log("contentList",contentList.data);
    const newContentlist = contentList?.data;

    const matchedRestaurantRecord = newContentlist.find(item => item._id === restaurant_id)
    console.log("matchedRestaurantRecord",matchedRestaurantRecord);
    console.log('location',location);
    
    props.history.push({pathname: `/restaurant/edit`,state: { ...location.state,currentRestaurant:matchedRestaurantRecord}}); 

    // props.history.push({pathname:'users'});
    // props.history.push({pathname: `/users/update`,state: { editUser:userData,}}); // type: activeRole.type, ...location.state,
    // const path = (location.pathname.split("/"))[1] || 'content';
    // console.log('path',path);
    
  }

  const onTabHandler = (e, tab) => {
    e.preventDefault();
    let tabKey = tab.key.toLowerCase(); 
    if(tabKey === 'branch')
      props.history.push({pathname: `/${tabKey}`,state: {restaurant_id: userData.restaurant_id}}); 
    else if(tabKey === 'table')
      props.history.push({pathname: `/${tabKey}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else if(tabKey === 'category')
      props.history.push({pathname: `/${tabKey}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else if(tabKey === 'menu')
      props.history.push({pathname: `/${tabKey}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else if(tabKey === 'admin-category')
      props.history.push({pathname: `/${tabKey}`}); 
    else if(tabKey === 'admin-menu')
      props.history.push({pathname: `/${tabKey}`});
    else if(tabKey === 'order')
      props.history.push({pathname: `/${tabKey}`,state: {branch_id: userData.restaurant_branch_id}}); 
    else
      props.history.push({pathname: `/${tabKey}`,state: {mainActiveParentCategory:tab.subItems?.length>0 ? tab.subItems[0] : null, currentUser:userData}}); 
    setActiveTab(tab.key); 
    if(tab.subItems?.length>0) setActiveSubTab(tab.subItems[0].text)
    //console.log("yess parent caleddddd",activeTab)
  };

  const onSubItemHandler = (e, tab, index) => {
    e.preventDefault();
    let tabKey = tab.key.toLowerCase(); 
    props.history.push({pathname: `/${tabKey}`,state: {mainActiveParentCategory:tab.subItems?.length?tab.subItems[index]:null, currentUser:userData}}); 
    setActiveTab(tab.key); 
    setActiveSubTab(tab.subItems[index].text);
    //console.log(tab.subItems[index].text,"yess sub caleddddd",activeTab)
  };
  
  const handleDrawer = () => {
    // window.navigator.vibrate(11500);
    // window.navigator.vibrate([500, 200, 800]);
    if(isSmallScreen){
      setOpen(!open);
    }
    

  };
  useEffect(() => {
    setOpen(!isSmallScreen); // Update the state when the screen size changes
  }, [isSmallScreen]);

  const dispatch = useDispatch()
  const accountDetails = useSelector(state => state.authReducer);


  const helpClose = () => {
    dispatch(helpHandler({open: false, data: null}))
  }

  useEffect(() => {
    setProfileOption(false)//close profile option i.e logout
    helpClose() // close help section
  }, []) //props-> this props is removed because of this warning given below
 // Warning: Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render. 

  useEffect(()=>{
    if(accountDetails.loggedInSuccess==false){ onLogout(); }
  }, [accountDetails.loggedInSuccess]);
  // const isSmallScreen = useMediaQuery('(max-width:1199px)');


  
  return (
        <div className="main-sidebar">
          <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
              [classes.appBarShift1]: !open,
            })}
          >
            {/*<Toolbar style={{background: 'white', color: 'black', justifyContent: 'space-between'}}>*/}
            <Toolbar className="top-toolbar">
              <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{backgroundColor: 'transparent'}}
                    className={'display-flex ' + clsx(classes.logoTextContainer, {
                      [classes.logoTextContainerOpen]: open,
                      [classes.logoTextContainerClose]: !open,
                    })}
                    classes={{
                      paper: clsx({
                        [classes.logoTextContainer]: open,
                        [classes.logoTextContainerClose]: !open,
                      }),
                    }}
                >
      
                </div>
                {/* {!isSmallScreen && ( */}
                <ListItemIcon onClick={handleDrawer} className='toggle-button-margin cursor-pointer'>
                  <img src={menuIcon}/>
                  {/*<menuIcon/>*/}
                  {/*<MenuIcon style={{color: 'white'}}/>*/}
                </ListItemIcon>
                {/* )} */}
              </div>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <div className='logout-container cursor-pointer' onClick={() => setProfileOption(!profileOption)}>
                  <img src={userProfile} alt={'profile'} title='Profile' className=' user-profile-icon'/>
                  <span className='text-capitalize font-14  text-white-normal text-bold'>{userData?.name} </span>
                  <img src={downArrow} alt={'options'} title='Profile' className=' ml-10' style={{width: 15}}
                  />
                  {profileOption && <div style={{}} className='logout-option-container'>
                    {   
                      userData?.role_id?._id === '661fa91d0f11708b9bc19d44' &&(
                        <PrimaryButton onClick={e => viewProfile()} value='View Profile' className={'m-0'} />)
                    }
                    <PrimaryButton onClick={e => dispatch(logout()) && onLogout()} value='↶ Logout' className={'m-0'}/>
                    
                    {/*<button className='btn custom-btn btn-3 btn-4'><span>logout</span>              </button>*/}

                  </div>}
                </div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path d="M21.5123 16.0783L17.7403 22.2333C17.326 22.9133 16.7622 23.4898 16.0915 23.9191C15.4209 24.3483 14.6612 24.6189 13.8703 24.7103C13.6618 24.735 13.4521 24.7474 13.2423 24.7473C12.1677 24.7458 11.1199 24.4122 10.2423 23.7923C9.33531 24.4717 8.21499 24.8039 7.08427 24.7285C5.95354 24.6531 4.88722 24.1752 4.07851 23.3813C3.26979 22.5875 2.77217 21.5302 2.67582 20.4011C2.57946 19.272 2.89074 18.1457 3.55326 17.2263L2.23826 15.9133C1.67675 15.3517 1.24957 14.6704 0.988709 13.9204C0.727845 13.1704 0.640058 12.371 0.731922 11.5822C0.823786 10.7935 1.09292 10.0357 1.51917 9.36566C1.94542 8.69564 2.51773 8.13074 3.19326 7.71327L8.96026 4.14727C10.5225 3.14605 12.3596 2.66063 14.2125 2.75949C16.0654 2.85835 17.8405 3.53651 19.2873 4.69827L20.9463 3.03927C21.0385 2.94376 21.1488 2.86758 21.2709 2.81517C21.3929 2.76276 21.5241 2.73518 21.6569 2.73402C21.7896 2.73287 21.9213 2.75817 22.0442 2.80845C22.1671 2.85873 22.2788 2.93299 22.3727 3.02688C22.4665 3.12077 22.5408 3.23242 22.5911 3.35532C22.6414 3.47822 22.6667 3.6099 22.6655 3.74268C22.6644 3.87545 22.6368 4.00667 22.5844 4.12868C22.5319 4.25068 22.4558 4.36103 22.3603 4.45327L20.7033 6.11127C21.8146 7.50351 22.4852 9.1957 22.6294 10.9713C22.7735 12.7468 22.3845 14.525 21.5123 16.0783ZM8.71826 22.3943L4.99926 18.6743C4.70863 19.194 4.59654 19.7948 4.68018 20.3844C4.76381 20.974 5.03855 21.5198 5.46226 21.9383C5.88968 22.3443 6.43333 22.6065 7.01715 22.6883C7.60097 22.77 8.19575 22.6672 8.71826 22.3943ZM18.6393 6.79427C17.5288 5.67311 16.067 4.9673 14.4984 4.79491C12.9299 4.62253 11.3497 4.99404 10.0223 5.84727L4.24526 9.41327C3.8263 9.67224 3.47136 10.0226 3.20701 10.4382C2.94267 10.8538 2.77578 11.3238 2.71883 11.8131C2.66189 12.3023 2.71636 12.7981 2.87819 13.2633C3.04001 13.7284 3.30498 14.151 3.65326 14.4993L10.9433 21.7903C11.2921 22.1395 11.7156 22.4051 12.1818 22.5671C12.6481 22.7291 13.1451 22.7832 13.6353 22.7255C14.1255 22.6677 14.5962 22.4996 15.0121 22.2336C15.428 21.9677 15.7781 21.611 16.0363 21.1903L19.7913 15.0653C20.5247 13.748 20.809 12.2277 20.6011 10.7344C20.3932 9.24109 19.7045 7.85617 18.6393 6.78927V6.79427ZM19.9183 24.7473C19.7071 24.7477 19.5012 24.6812 19.3301 24.5573C19.159 24.4335 19.0315 24.2587 18.9659 24.058C18.9003 23.8572 18.8999 23.6409 18.9648 23.4399C19.0298 23.239 19.1566 23.0637 19.3273 22.9393C21.0783 21.6228 22.2633 19.6899 22.6423 17.5323C22.6688 17.4024 22.721 17.2791 22.7956 17.1695C22.8703 17.06 22.966 16.9664 23.0772 16.8941C23.1883 16.8219 23.3128 16.7725 23.4432 16.7488C23.5737 16.7251 23.7075 16.7276 23.837 16.7561C23.9665 16.7846 24.089 16.8386 24.1974 16.9149C24.3058 16.9911 24.398 17.0882 24.4686 17.2005C24.5391 17.3127 24.5867 17.4379 24.6084 17.5687C24.6302 17.6994 24.6257 17.8332 24.5953 17.9623C24.1053 20.5939 22.6467 22.9463 20.5073 24.5553C20.3362 24.68 20.13 24.7472 19.9183 24.7473ZM1.65326 6.48627C1.46856 6.48545 1.2877 6.43349 1.13073 6.33616C0.973758 6.23882 0.84681 6.09992 0.763962 5.93484C0.681114 5.76977 0.645601 5.58497 0.661363 5.40095C0.677125 5.21692 0.743545 5.04086 0.853258 4.89227C2.48424 2.71286 4.88508 1.2376 7.56626 0.767274C7.82617 0.714231 8.09651 0.76661 8.3178 0.912888C8.53909 1.05917 8.69321 1.28736 8.74626 1.54727C8.7993 1.80719 8.74692 2.07752 8.60064 2.29882C8.45436 2.52011 8.22617 2.67423 7.96626 2.72727C5.76423 3.0909 3.78849 4.2929 2.45326 6.08127C2.36064 6.20639 2.24008 6.30816 2.1012 6.37847C1.96231 6.44878 1.80893 6.48569 1.65326 6.48627Z" fill="white"/>
                  </svg>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          {/* {!isSmallScreen && ( */}
          <Drawer
            variant="permanent"
            className={clsx('drawer-width '+classes.drawer, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            })}
            classes={{
              paper: clsx({
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              }),
            }}
          > 
            {/* <img className="sidebar-bg" src={sidebarBg} /> */}
            <List style={{paddingRight: 5, backgroundColor: '#fff', height: '90vh', overflow: 'auto'}}>
              <div className={`logo ${!open && 'small-logo'}`}>
                {/* <img src={logoBlack} className={'hoverIt'} onClick={(e) => movetoFrontend()}/> */}
                <img src={cmsLogo} className={'hoverIt'} onClick={(e) => movetoFrontend()}/>
              </div>
              <ListItem className={'sidebar-tab-text pb-0 text-black-normal m-0'}>
                <ListItemText
                  primary={''}
                  className={`text-capitalize ${open ? 'display-flex' : 'display-none'}`}
                />
              </ListItem>
              {(sideBarOptions || []).map((obj, index) => {
                if(obj.key.toLowerCase()=='user' && userData && userData.email !='superadmin@gmail.com')
                  return('');

                // if(userData.mod?.includes(obj.routeName))
                //   return('');

                let key = obj.key.toLowerCase();
                let [textClass, iconColor] = (activeTab == key) ? ["active-tab", "white_icon"] : ["sidebar-tab-text", "black_icon"];

                let IconT = obj.icon;
                return (
                  <React.Fragment key={`tabList ${index}`}>
                    <ListItem
                      button
                      onClick={(e) => onTabHandler(e, obj)}
                      className={`position-relative tab-margin ${textClass}`}
                      style={{paddingLeft: 10, paddingRight: 10}}
                    >
                      {obj.icon && 
                      <ListItemIcon className='sidebar-tab-icon' onClick={handleDrawer}>
                        {/*<IconT className={iconColor}/>*/}
                        <span className="colorGreen">
                          {/*<img src={obj.icon} className={`sidebar-tab-icon ${iconColor}`}*/}
                          <img src={activeTab == key ? obj.activeIcon : obj.icon} className={`sidebar-tab-icon `}
                              alt={""}/>
                              
                        </span>
                        {/*<img src={dashboardIcon} className={iconColor} alt={""}/>  userData?.role?._id!='63314f7edd5ccc5c401ab035' ? */}
                      </ListItemIcon>}
                      <ListItemText onClick={handleDrawer}
                        primary={obj.text.replace(/_/g, " ")}
                        className={`text-capitalize list-item-text ${open ? 'display-flex' : 'display-none'}`}
                      />
                    </ListItem>

                    {obj.subItems?.length &&
                    (<Collapse
                        key={`subItem ${index}`}
                        compoobjnent="li"
                        in={activeTab==obj.key}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List disablePadding className="sub-items-margin">
                            { obj.subItems?.map(
                                (sitem,indexx) => {
                                  let [subTextClass] = activeSubTab == sitem.text ? ["active-sub-tab", "white_icon"] : ["sidebar-sub-tab-text", "black_icon"];
                                  let subIcon = activeSubTab == sitem.text ? activeSubTabIcon : subTabIcon;
                                    return (
                                        <ListItem
                                            button
                                            onClick={(e) => onSubItemHandler(e, obj, indexx)}
                                            key={
                                                sitem.value
                                            }
                                            className={`position-relative ${subTextClass}`}
                                            style={{ paddingLeft:'15px'}}
                                        >
                                            {/* {sitem.icon &&  */}
                                            <ListItemIcon className='sidebar-tab-icon-sub'>
                                              {/*<IconT className={iconColor}/>*/}
                                              <span className="colorGreen">
                                                {/*<img src={obj.icon} className={`sidebar-tab-icon ${iconColor}`}*/}
                                                <img src={subIcon}
                                                    alt={""}/>
                                              </span>
                                              {/*<img src={dashboardIcon} className={iconColor} alt={""}/>  userData?.role?._id!='63314f7edd5ccc5c401ab035' ? */}
                                            </ListItemIcon>
                                            {/* } */}
                                            <ListItemText
                                                key={
                                                    sitem.value
                                                }
                                                className={`text-capitalize`}
                                                primary={
                                                    sitem.text
                                                }
                                            />
                                        </ListItem>
                                    );
                                }
                            )}
                        </List>
                    </Collapse>
                    )}
                    {/*<Divider/>*/}
                  </React.Fragment>
                );
              })}
            </List>
          </Drawer>
           {/* )} */}

        {/* code for bottom navigation which is the alternative of Drawer for lessthan 1299px screens  */}
        {/* {isSmallScreen && (
          <BottomNavigation
            value={activeTab} // Make sure to set the value prop to manage the selected tab
            onChange={(event, newValue) => setActiveTab(newValue)} // Handle tab changes
            className={clsx(classes.bottomNavigation, { // Apply custom styles to the bottom navigation
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            })}
          >
            {(sideBarOptions || []).map((obj, index) => {
              if (obj.key.toLowerCase() === 'user' && userData && userData.email !== 'superadmin@gmail.com') return null;

              let key = obj.key.toLowerCase();
              let [textClass, iconColor] = (activeTab === key) ? ["active-tab", "white_icon"] : ["sidebar-tab-text", "black_icon"];

              let IconT = obj.icon;
              
              return (
                <BottomNavigationAction
                  key={`tabList ${index}`}
                  onClick={(e) => onTabHandler(e, obj)}
                  label={obj.text.replace(/_/g, " ")}
                  className={`position-relative tab-margin ${textClass}`}
                  icon={<span className="colorGreen">
                    <img src={activeTab === key ? obj.activeIcon : obj.icon} className={`sidebar-tab-icon `} alt={""}/>
                  </span>}
                  value={key} // Set the value prop of each action to its corresponding key
                />
              );
            })}
          </BottomNavigation>
        )} */}



        </div>
  );
}
const mapStateToProps = ({restaurantReducer={}}) => {
  return {restaurantReducer};
};
const mapDispatchToProps = (dispatch) => {
  return {
    getContentStart: (data) => dispatch(getContentList(data))
  }
}; 

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MySidebar));
// export default withRouter(MySidebar);
// export default [withRouter(MySidebar),connect(mapStateToProps,mapDispatchToProps)];
